/* SS06146: which column mapping the import designer keeps once an importData request returns.

   The server echoes back the columns it was SENT, so its copy is only as new as the moment the
   request left. A mapping edited while the request was in flight (uploading the file already
   starts one, and Refresh Data starts another) used to be overwritten by that stale echo --
   the user's "Document ID" mapping silently vanished. Keep the designer's columns whenever they
   changed during the request; otherwise take the server's (the first load, or a new file whose
   spreadsheet columns differ). */
export function columnsAfterImport({ userImport, sentSnapshot, current, returned }) {
  const hasCurrent = Array.isArray(current) && current.length > 0;

  // a user import keeps whatever columns it already has
  if (userImport && hasCurrent) return current;

  if (hasCurrent && sentSnapshot !== undefined && JSON.stringify(current) !== sentSnapshot) {
    return current;
  }

  return returned;
}
